import { pieceRouteParam } from '@/features/piece-catalog/lib/catalog-navigation';

export const ADMIN_CATALOG_PATH = '/internal-admin/catalog';

export const adminCatalogPiecePath = (pieceName: string): string =>
  `${ADMIN_CATALOG_PATH}/${encodeURIComponent(pieceRouteParam(pieceName))}`;
